const forgotPasswordES = {
	title: "¿Olvidaste tu contraseña?",
	subtitle: "Ingresa tu correo y te enviaremos un enlace para restablecerla.",
	email: "Correo electrónico",
	send: "Enviar enlace",
	sending: "Enviando...",
	success: "Revisa tu correo para restablecer tu contraseña.",
	toast: {
		error: "No se pudo enviar el correo. Inténtalo de nuevo.",
	},
};

export default forgotPasswordES;
